import { Typography } from '@mui/material';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export var PushNotificationHeader = function PushNotificationHeader() {
  return /*#__PURE__*/_jsx(Typography, {
    variant: "h3",
    sx: {
      flexGrow: 1
    },
    "data-element": "Typography",
    "data-component": "PushNotificationHeader",
    "data-source-file": "push-notification-header.tsx",
    children: /*#__PURE__*/_jsx(Translation, {
      "data-element": "Translation",
      "data-component": "PushNotificationHeader",
      "data-source-file": "push-notification-header.tsx",
      children: function children(t) {
        return t('Push notifications');
      }
    })
  });
};